/**
 * Renderização de templates de e-mail `{{chave}}` — ÚNICA implementação (os
 * módulos mail e automations da API re-exportam daqui; duplicar a semântica
 * foi vetado em review: os dois renderizadores não podem divergir sobre o
 * mesmo template). Os placeholders POSICIONAIS `{{n}}` de template HSM do
 * WhatsApp têm gramática/render próprios em ./whatsapp.ts
 * (TEMPLATE_PLACEHOLDER_RE / renderTemplateParams) — também fonte única, com
 * semântica de ausência diferente (lá o placeholder sem valor fica intacto).
 *
 * Semântica (spec §5):
 * - chaves `[A-Za-z0-9_.]+` — pontos permitidos (`{{ticket.number}}`), mas o
 *   mapa `vars` é PLANO: a chave é a string literal 'ticket.number', não um
 *   caminho aninhado;
 * - espaços internos tolerados: `{{ ticket.number }}` ≡ `{{ticket.number}}`;
 * - variável ausente, null ou undefined vira string VAZIA;
 * - valores substituídos NÃO são re-escaneados (sem expansão recursiva).
 */
export function renderTemplate(
  source: string,
  vars: Record<string, string | number | null | undefined>
): string {
  return source.replace(/\{\{\s*([A-Za-z0-9_.]+)\s*\}\}/g, (_match, key: string) => {
    const value = vars[key];
    return value === null || value === undefined ? '' : String(value);
  });
}

/**
 * As variáveis que os templates de ticket suportam — fonte única para a UI
 * (lista de chaves clicáveis) e para os montadores de `vars` da API.
 */
export const TEMPLATE_VARIABLE_NAMES = [
  'ticket.number',
  'ticket.title',
  'ticket.stage',
  'ticket.status',
  'ticket.priority',
  'client.name',
  'desk.name',
  'responsible.name',
] as const;

export type TemplateVariableName = (typeof TEMPLATE_VARIABLE_NAMES)[number];
